import React from "react";

import { ReactComponent as SignalIcon } from "../../../assets/status/signal_excellent.svg";
import { ReactComponent as SignalWeakIcon } from "../../../assets/status/signal_weak.svg";
import { ReactComponent as SignalWarningIcon } from "../../../assets/status/signal_warning.svg";
import I18nText from "../../../elements/I18nText";

const SignalIndicator = ({ value: raw }) => {
  const max = 31;
  const value = Math.max(0, Math.min(max, Number(raw ?? 0)));

  let text = "devices.status.signal.stable";
  let icon = <SignalIcon />;
  if (value < 10) {
    icon = <SignalWeakIcon />;
    text = "devices.status.signal.weak";
  } else if (value <= 20) {
    icon = <SignalWarningIcon />;
    text = "devices.status.signal.low";
  }

  return (
    <span style={{ display: "inline-flex", alignItems: "center", gap: 6 }}>
      {icon && <span style={{ width: 24, height: 24 }}>{icon}</span>}
      <span>
        <I18nText>{text}</I18nText>
      </span>
    </span>
  );
};
export default SignalIndicator;
